import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useEventEmitter } from "../../contexts/EventEmmiter";
import renameIcon from "../../assets/images/editIcon.svg";
import deleteIcon from "../../assets/images/deleteIcon.svg";
import { ConfirmModal } from "../../pages/Chat/Chat"; 
import { postUserThread, postDeleteThread, postRenameThread } from "../../store/apiActions";
import { env } from "../../environment"
import ReactDOM from "react-dom";
import { useLocation } from "react-router-dom";

const getUsername = () => {
  const storedData = localStorage.getItem("LoggedInDetails");
  if (storedData) {
    const parsedData = JSON.parse(storedData);
    return parsedData.username;
  }
  return null;
};

function Threads({ isUpdateThread, onNewChatClick, onThreadSelect}) {
  const [threads, setThreads] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const savedThreadId = localStorage.getItem("sessionId");
  const location = useLocation();
  const [selectedThreadId, setSelectedThreadId] = useState(
    Number(savedThreadId)
  );
  const [showModalMore, setShowModalMore] = useState(false);
  const [editTitle, setEditTitle] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });
  const { emit, subscribe } = useEventEmitter();
  const [openedModelIndex, setOpenedModelIndex] = useState(null);
  const [openedThreadId, setOpenedThreadId] = useState(null);
  const modalRef = useRef(null);
  const [hoveredThreadId, setHoveredThreadId] = useState(null);
  const [hoveredItemIndex, setHoveredItemIndex] = useState(null);
  const dispatch = useDispatch();
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const username = getUsername();

  const handleThreadClick = (sessionId) => {
    emit("thread", sessionId);
    setSelectedThreadId(sessionId);
    localStorage.setItem("sessionId", sessionId);
    if (onThreadSelect) {
      onThreadSelect(); // Callback for mobile sidebar to close it
    }
    // emit("closeSidebar");
  };
 useEffect(() => {
     const handleResize = () => {
       setIsMobile(window.innerWidth <= 768);
     };
 
     window.addEventListener("resize", handleResize);
     return () => window.removeEventListener("resize", handleResize);
   }, []);

  useEffect(() => {
  const unsubscribe = subscribe("resetSelectedThread", () => {
    setSelectedThreadId(null);
  });

  return () => unsubscribe();
}, [subscribe]);


   const openModal = (e, sessionId, itemIndex, currentTitle) => {
    const rect = e.target.getBoundingClientRect();
    setOpenedThreadId(sessionId);
    setOpenedModelIndex(itemIndex);
    setEditTitle(currentTitle);
    setShowModalMore(true);
    setModalPosition({
      top: rect.bottom + window.scrollY + 5,
      left: rect.left + window.scrollX - 10,
    });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setShowModalMore(false);
        setOpenedThreadId(null);
        setOpenedModelIndex(null);
        setIsEditing(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (isEditing && modalRef.current) {
      modalRef.current.focus();
    }
  }, [isEditing]);

  const handleRenameItem = async (item) => {
    if (editTitle.trim() === "") {
      alert("Title cannot be empty.");
      return;
    }
    setEditTitle("");
    setIsEditing(false);
    setShowModalMore(false);
    setOpenedThreadId(null);
    setOpenedModelIndex(null);
    const payload = {
      user_id: username,
      session_id: item?.session_id,
      thread_name: editTitle,
      delete_flag: false,
    };
    try {
      await dispatch(postRenameThread(`${env.baseURL}/rename-user-thread`, payload));
      emit("closeSidebar");
      toast.success("Thread renamed successfully");
      setTimeout(() => {
        handleNewChatFun();
      }, 100);
    } catch (err) {
      toast.error("Rename failed");
      console.error("Rename API error:", err);
    }
  };

  const handleMouseEnter = (sessionId, index) => {
    setHoveredThreadId(sessionId);
    setHoveredItemIndex(index);
  };

  const handleOpenDeleteModal = () => {
    setShowDeleteModal(true);
    setShowModalMore(false);
  };

  const handleDelete = async (item) => {
    const payload = {
      user_id: username,
      session_id: item?.session_id,
    };
    try {
      await dispatch(postDeleteThread(`${env.baseURL}/delete-user-thread`, payload));
      setTimeout(() => {
        handleNewChatFun();
        emit("clearChat");
      }, 100);
      toast.success("Thread deleted successfully");
    } catch (err) {
      toast.error("Delete failed");
      console.error("Delete API error:", err);
    }
    };

  const handleMouseLeave = () => {
    setHoveredThreadId(null);
    setHoveredItemIndex(null);
  };

  const threadResponse = useSelector(
    (state) => state?.api?.userThreadDetails?.data || []
  );
    useEffect(() => {
    const unsubscribe = subscribe("refreshThreads", () => {
        handleNewChatFun();
    });
    return () => unsubscribe();
    }, [subscribe]);


    useEffect(() => {
    if (!threadResponse?.threads?.length) return;
    setThreads(threadResponse.threads);
    const storedSessionId = localStorage.getItem("sessionId");
    const matchingThread = threadResponse.threads.find(
        thread => thread?.session_id === storedSessionId
    );
    if (matchingThread) {
        setSelectedThreadId(matchingThread.session_id);
        handleThreadClick(storedSessionId);
    }
    }, [threadResponse]);

    const handleNewChatFun = async () => {
    const payload = {
        user_id: username,
        ugdn_id: username,
        delete_flag: false,
    };
    try {
        const response = await dispatch(
            postUserThread(`${env.baseURL}/fetch-user-threads`, payload)
        );
        const threadsFromAPI = response?.threads || [];
        setThreads(threadsFromAPI);
    } catch (error) {
        console.error("Error fetching threads:", error);
    }
};


  useEffect(() => {
    handleNewChatFun();
  }, []);

  useEffect(() => {
    if (isUpdateThread === true) {
      handleNewChatFun();
    }
  }, [isUpdateThread]);

  const handleConfirmNewChat = () => {
    emit("newChat", true);
    if (onNewChatClick) {
      onNewChatClick();
    }
  };

  return (
    <>
    {(location?.pathname === "/chat" &&
    <div className="threads-container">
    {!isMobile && (
      <div className="add-thread">
        <div className="add-new-button-container">
          <button
            onClick={handleConfirmNewChat}
            className="add-thread-button"
          >
            + New Chat
          </button>
        </div>

      </div>
      )}
      {/* <div className="sidebar-section-title">Today</div> */}
      <div className="scrollable-threads">
        {threads?.length > 0 ? (
          <div className="thread-card">
            <div className="thread-items">
              {threads.map((item, index) => {
                const sessionId = item?.session_id;
                const isSelected = selectedThreadId === sessionId;
                const isHovered = hoveredThreadId === sessionId && hoveredItemIndex === index;
                const isOpen = openedThreadId === sessionId && openedModelIndex === index;
                const uniqueKey = `${sessionId}-${index}`;

                return (
                  <div
                    key={uniqueKey}
                    className={`thread-item-wrapper ${isSelected ? "selected" : ""}`}
                   
                    onMouseEnter={() => handleMouseEnter(sessionId, index)}
                    onMouseLeave={handleMouseLeave}
                  >
                    {isEditing && isOpen ? (
                      <input
                        ref={modalRef}
                        type="text"
                        value={editTitle}
                        onChange={(e) => setEditTitle(e.target.value)}
                        className="rename-input"
                        onKeyDown={(e) => {
                          if (e.key === "Enter") handleRenameItem(item);
                          if (e.key === "Escape") setIsEditing(false);
                        }}
                        autoFocus
                      />
                    ) : (
                      <div className="thread-item-content"
                        onClick={(e) => {
                          if (isMobile) {
                            emit("closeSidebar");
                          }
                          handleThreadClick(sessionId);

                        }}
                      >
                        <span className="thread-item-text"
                        >{item?.thread_title}</span>
                      </div>
                    )}

                   {(isHovered || (isOpen && showModalMore) || isMobile) && (
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          openModal(e, sessionId, index, item?.thread_title);
                        }}
                        className="thread-item-more"
                      >
                        ⋮
                      </button>
                    )}

                    {isOpen && showModalMore && (
                      <div
                        ref={modalRef}
                        style={{
                          ...styles.modal,
                          top: modalPosition.top,
                          left: modalPosition.left,
                          display: "block",
                        }}
                      >
                        <div className="modal-container">
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              setIsEditing(true);
                              setShowModalMore(false);
                              setEditTitle(item?.thread_title);
                            }}
                            className="modal-button"
                          >
                            <img src={renameIcon} alt="Rename" className="icon" />
                            Rename
                          </button>
                          <button
                            onClick={(e) => {handleOpenDeleteModal();
                              e.stopPropagation()}
                            }
                            className="modal-button delete"
                          >
                            <img src={deleteIcon} alt="Delete" className="icon" />
                            Delete
                          </button>
                        </div>
                      </div>
                    )}

                    {isOpen && showDeleteModal && ReactDOM.createPortal(
                      <ConfirmModal
                        show={showDeleteModal}
                        title="Delete Item"
                        message="Are you sure you want to delete this item?"
                        primaryBtnText="Cancel"
                        secondaryBtnText="Delete"
                        onPrimaryClick={() => {
                            setShowDeleteModal(false); 
                            emit("closeSidebar");
                        }}
                        onSecondaryClick={async() => {
                          await handleDelete(item);
                          setShowDeleteModal(false);
                          emit("closeSidebar");
                        }}
                      />,
                      document.body
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          <div className="no-threads-msg">No threads to show</div>
        )}
      </div>
    </div>
    )}
    </>
  );
}

export default Threads;
const styles = {
  threadItems: {
    marginTop: "10px",
  },
  threadItem: {
    fontSize: "15px",
    color: "#666",
    height: "20px",
  },
  modal: {
    position: "absolute",
    backgroundColor: "#fff",
    borderRadius: "8px",
    boxShadow: "0 5px 15px rgba(0, 0, 0, 0.3)",
    zIndex: 100,
    display: "none",
    textAlign: "center",
    border: "1px solid #ddd",
  },
};
